export { isInTeacherPlatform, linkToTeacherDashboard } from "./teacher/links";

export { linkToTeacherWhatIsPremiumPage } from "./teacher/routes/what-is-premium/links";

export {
  linkToTeacherHomepage,
  linkToTeacherFeedback
} from "./teacher/routes/homepage/links";

export { linkToClassPage } from "./teacher/routes/class/links";
export { linkToClassesPage } from "./teacher/routes/classes/links";
export { linkToCreateNewClass } from "./teacher/routes/classes/routes/create-new-class/links";

export { linkToClassOverviewPage } from "./teacher/routes/class/routes/overview/links";

export { linkToInviteStudentsToClassPage } from "./teacher/routes/class/routes/invite-students/links";

export { linkToClassStudentsPage } from "./teacher/routes/class/routes/students/links";

export { linkToClassCoursesPage } from "./teacher/routes/class/routes/courses/links";

export { linkToClassAssignmentsPage } from "./teacher/routes/class/routes/assignments/routes/links";

export { linkToAssignmentPage } from "./teacher/routes/class/routes/assignments/routes/assignment/links";

export { linkToClassSettingsPage } from "./teacher/routes/class/routes/settings/links";

export { linkToClassInsightsPage } from "./teacher/routes/class/routes/insights/links";

export { linkToResourcesHub } from "./teacher/routes/resources/links";

export { linkToAddCoursesPage } from "./teacher/routes/class/routes/add-courses/links";

export { linkToAddClassCoursesWithFreeSelected } from "./teacher/routes/class/routes/add-courses/links";

export { linkToCreateClassAssignment } from "./teacher/routes/class/routes/create-assignment/links";

export { linkToRemoveClassCourseModal } from "./teacher/routes/class/routes/courses/routes/remove-course/links";

export { linkToManageStudentsPage } from "./teacher/routes/class/routes/students/routes/manage/links";

export { isLinkToInvite } from "./teacher/routes/classes/routes/invite/links";

export {
  linkToProgress,
  linkToProgressReportModal
} from "./teacher/routes/progress/links";

export { linkToSchoolPage } from "./teacher/routes/school/links";
